<template>
  <section class="ed-section">
    <header class="ed-section__head">
      <div class="ed-section__titles">
        <h3 class="ed-section__title">{{ title }}</h3>
        <p v-if="description" class="ed-section__description">{{ description }}</p>
      </div>
      <div v-if="$slots.aside" class="ed-section__aside"><slot name="aside"></slot></div>
    </header>
    <div class="ed-section__body"><slot></slot></div>
  </section>
</template>

<script>
// Cartão de um grupo de campos do editor: título, explicação curta e conteúdo.
export default {
  name: "EditorSection",
  props: {
    title: { type: String, required: true },
    description: { type: String, default: null },
  },
};
</script>

<style scoped>
.ed-section {
  background: var(--ced-surface, #fff);
  border: 1px solid var(--ced-border, #e3e5ec);
  border-radius: var(--ced-radius, 10px);
  padding: 20px 24px 22px;
}
.ed-section + .ed-section {
  margin-top: 16px;
}
.ed-section__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}
.ed-section__title {
  font-size: 16px;
  font-weight: 700;
  color: var(--ced-text, #4c4d4f);
  margin: 0;
  line-height: 1.3;
}
.ed-section__description {
  font-size: 13px;
  color: var(--ced-muted, #80849a);
  margin: 4px 0 0;
  max-width: 68ch;
  line-height: 1.5;
}
.ed-section__aside {
  flex-shrink: 0;
}
</style>
